import { snowtrade } from "../../../../api";

export const sendAcceptBookingRequestRequest = (leadId) =>
  snowtrade.patch(`/api/sales/leads/${leadId}/property/booking/accept`);

export const sendDeclineBookingRequestRequest = (leadId) =>
  snowtrade.patch(`/api/sales/leads/${leadId}/property/booking/decline`);
